import { type Report, type Routine } from '@littlebird/sdk';
import {
  getRoutineActionState,
  type RoutineActionState,
  type RoutineRunViewModel,
} from '@littlebird/ui-utils';

/**
 * `latestCompletedRun`: `undefined` while runs load, `null` once none exists.
 * `newestRun`: the routine's newest run, whose waiting device blocks Run.
 * `isRunPending`: the run-now request is in flight.
 */
export const getRoutineActions = (
  routine: Routine,
  latestCompletedRun?: RoutineRunViewModel | null,
  newestRun?: Report,
  isRunPending?: boolean
): RoutineActionState =>
  getRoutineActionState(
    {
      isPaused: routine.isPaused,
      isAdminPaused: routine.isAdminPaused,
      isExperimental: routine.isExperimental,
      permissions: routine.permissions ?? undefined,
      newestRun,
      isRunPending,
    },
    latestCompletedRun
  );

/** `getRoutineActions` for a routine whose newest run comes from the report store */
export const getRoutineActionsWithLatestRun = (
  routine: Routine,
  reports: { latestByTemplateId: ReadonlyMap<number, Report> },
  isRunPending?: boolean
): RoutineActionState =>
  getRoutineActions(
    routine,
    undefined,
    reports.latestByTemplateId.get(routine.referenceId),
    isRunPending
  );
